/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HeaderRefetchQueryVariables = {
    isClient?: boolean | null;
    userId: string;
    userIds: ReadonlyArray<string | null>;
    hasUserId: boolean;
    showMarketingMessages: boolean;
    hasMarketingBannerPreviewVariables?: boolean | null;
    marketingBannerPreviewUserType?: string | null;
    marketingBannerPreviewSetId?: string | null;
    marketingBannerIsFirstTimeVisitor?: boolean | null;
    fetchRegionalInfo: boolean;
    fetchTradeNav: boolean;
    fetchNav: boolean;
    previewKey?: string | null;
    zipCode: string;
    userCountryCode?: string | null;
    hasSessionCountryCode: boolean;
};
export type HeaderRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Header_viewer">;
    } | null;
};
export type HeaderRefetchQuery = {
    readonly response: HeaderRefetchQueryResponse;
    readonly variables: HeaderRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isClient",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "showMarketingMessages",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasMarketingBannerPreviewVariables",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "marketingBannerPreviewUserType",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "marketingBannerPreviewSetId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "marketingBannerIsFirstTimeVisitor",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "fetchRegionalInfo",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchTradeNav",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchNav",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "previewKey",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "zipCode",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userCountryCode",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "hasSessionCountryCode",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "INTERNATIONAL"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "rootId",
  "variableName": "previewKey"
},
v4 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "path",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isLinkable",
    "args": null,
    "storageKey": null
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": (v4/*: any*/)
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "modules",
    "storageKey": null,
    "args": null,
    "concreteType": "NavigationModule",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "imageLinkData",
        "storageKey": null,
        "args": null,
        "concreteType": "LinkData",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageTitlePrimary",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageTitleSecondary",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageHeight",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageWidth",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageLink",
        "args": null,
        "storageKey": null
      },
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isHighlighted",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": null,
        "concreteType": "NavigationTopLevel",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "column",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "items",
            "storageKey": null,
            "args": null,
            "concreteType": "NavigationItem",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      },
      (v7/*: any*/),
      (v2/*: any*/)
    ]
  },
  (v2/*: any*/)
],
v9 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds"
},
v10 = [
  {
    "kind": "Literal",
    "name": "relationshipType",
    "value": "VIP"
  },
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phoneNumber",
  "args": (v1/*: any*/),
  "storageKey": "phoneNumber(formatType:\"INTERNATIONAL\")"
},
v17 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "eventDate",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdDate",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "zipCode",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v26 = [
  (v22/*: any*/),
  (v25/*: any*/)
],
v27 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v28 = {
  "kind": "ScalarField",
  "alias": "thumbnail",
  "name": "firstPhotoWebPath",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v29 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "content",
  "storageKey": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cta",
      "storageKey": null,
      "args": null,
      "concreteType": "MarketingMessageCta",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "text",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v30 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "userType",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "items",
    "storageKey": null,
    "args": null,
    "concreteType": "MessageSetItem",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "impressionCap",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "note",
        "storageKey": null,
        "args": null,
        "concreteType": "MarketingMessage",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v29/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "anchors",
            "storageKey": null,
            "args": null,
            "concreteType": "MarketingMessage",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v29/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  }
],
v31 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "totalResults",
    "args": null,
    "storageKey": null
  }
],
v32 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userIds"
},
v33 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v34 = {
  "kind": "Literal",
  "name": "viewName",
  "value": "buyerTracking.confirmed"
},
v35 = [
  (v13/*: any*/)
],
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "countryCode",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "HeaderRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Header_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HeaderRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contactInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "ContactInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "phoneNumbers",
                "storageKey": null,
                "args": null,
                "concreteType": "support",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "tradeSupport",
                    "args": (v1/*: any*/),
                    "storageKey": "tradeSupport(formatType:\"INTERNATIONAL\")"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isNotificationsEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "NOTIFICATIONS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"NOTIFICATIONS\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isCartEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "CART"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"CART\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMessageCenterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "MESSAGE_CENTER"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isAutomatedOfferNotificationDisabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableAutomatedOfferBellNotification"
              }
            ],
            "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSuggestionsFeatureEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEARCH_BAR_SUGGESTIONS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEARCH_BAR_SUGGESTIONS\")"
          },
          (v2/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchNav",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "navigation",
                "storageKey": null,
                "args": [
                  (v3/*: any*/)
                ],
                "concreteType": "Navigation",
                "plural": false,
                "selections": (v8/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchTradeNav",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "tradeNavigation",
                "name": "navigation",
                "storageKey": null,
                "args": [
                  (v3/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "userType",
                    "value": "TRADE"
                  }
                ],
                "concreteType": "Navigation",
                "plural": false,
                "selections": (v8/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "vipRep",
                "name": "userRelationships",
                "storageKey": null,
                "args": (v10/*: any*/),
                "concreteType": "UserRelationship",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userDataB",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "VipRepData",
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "photoUrl",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "userRelationships",
                "storageKey": null,
                "args": (v10/*: any*/),
                "concreteType": "UserRelationship",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userDataB",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "VipRepData",
                        "selections": [
                          (v12/*: any*/),
                          (v16/*: any*/),
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": [
                  (v17/*: any*/)
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "verifiedTradeStatus",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVip",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "recentHistoryList",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RecentHistoryItem",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "contemporaryTrackingString",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstPhotoWebPath",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "small"
                              }
                            ],
                            "storageKey": "firstPhotoWebPath(size:\"small\")"
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pdpURL",
                            "args": null,
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "browseUrl",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "categoryCode",
                            "args": null,
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "categoryPath",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "seller",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Seller",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v2/*: any*/)
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v20/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstSessionDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "isTrade",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VERIFIED_TRADE"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_VERIFIED_TRADE\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "hasVipPermission",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VIP_CHECKOUT"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_VIP_CHECKOUT\")"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authMetadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserExistsMetadataType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "emailOnly",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasPassword",
                        "args": null,
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ]
                  },
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalMessagesToDealers",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tradeFirm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "tier",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "profileStatus",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "rewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentProgram",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "programInfo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  (v2/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "publicProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmPublicProfileType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "loyalty",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmLoyaltyType",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "members",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmMemberType",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "userId",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "publicProfileManager",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mentionMeTagParameters",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "mentionMeTagParameters",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "ciphertext",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "nonce",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "roles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserRoles",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "roleList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Role",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userData",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserRoleData",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "userStatus",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserRoleUserData",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "conversationSummary",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Summary",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "unread",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activePromotion",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Promotion",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "adjustmentRateList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "reference",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ]
                      },
                      (v7/*: any*/),
                      (v23/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "flatAdjustmentRate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FlatAdjustmentRate",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rate",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "plural": false,
                            "selections": (v26/*: any*/)
                          },
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "percentAdjustmentRate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PercentAdjustmentRate",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "rate",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ]
                      },
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activityFeed",
                    "storageKey": "activityFeed(elementTypes:[\"PENDING_FEEDBACK\",\"TRADE_REWARD\",\"TRADE_REWARD_PRORATED\",\"TRADE_REWARD_PROGRAM\",\"AUTOMATED_OFFER\"],first:3)",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "elementTypes",
                        "value": [
                          "PENDING_FEEDBACK",
                          "TRADE_REWARD",
                          "TRADE_REWARD_PRORATED",
                          "TRADE_REWARD_PROGRAM",
                          "AUTOMATED_OFFER"
                        ]
                      },
                      (v27/*: any*/)
                    ],
                    "concreteType": "ActivityFeedConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ActivityFeedEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ActivityFeedElement",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "type",
                                "args": null,
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              (v7/*: any*/),
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "apiType",
                                "args": null,
                                "storageKey": null
                              },
                              (v24/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "anchors",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sourceType",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "source",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v2/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "type": "TradeFirmReward",
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "rewardEarned",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "FinancialAmount",
                                            "plural": false,
                                            "selections": (v26/*: any*/)
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "ParentProgram",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "programInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "LoyaltyProgram",
                                            "plural": false,
                                            "selections": [
                                              (v12/*: any*/),
                                              (v23/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "iconUri",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v2/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "OrderFeedback",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "token",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "transaction",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "item",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Item",
                                                "plural": false,
                                                "selections": [
                                                  (v19/*: any*/),
                                                  (v28/*: any*/),
                                                  (v2/*: any*/)
                                                ]
                                              },
                                              (v2/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Transaction",
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "summary",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TransactionSummaryObject",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "offerDiscountPercentage",
                                                "args": null,
                                                "storageKey": null
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v19/*: any*/),
                                              (v28/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "pricing",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ItemPricing",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "retailPrice",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FinancialAmount",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "convertedAmountList",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "ConvertedAmountList",
                                                        "plural": true,
                                                        "selections": [
                                                          (v25/*: any*/),
                                                          (v22/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v2/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "mostRecentOffer",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Offer",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "amountPerItem",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "FinancialAmount",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "convertedAmountList",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ConvertedAmountList",
                                                    "plural": true,
                                                    "selections": (v26/*: any*/)
                                                  }
                                                ]
                                              },
                                              (v2/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "preferences",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "shareActivities",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "showMarketingMessages",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": "registeredUserMessages",
                        "name": "bannerMessages",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MessageSetModule",
                        "plural": true,
                        "selections": (v30/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "portfolios",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "CART"
                    ]
                  },
                  (v9/*: any*/)
                ],
                "concreteType": "PortfoliosConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": "items(first:3)",
                            "args": [
                              (v27/*: any*/)
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "conversations",
                "storageKey": "conversations(filter:\"showUnreadOnly\")",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": "showUnreadOnly"
                  }
                ],
                "concreteType": "ConversationConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "metadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ConversationMetadata",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastUnreadMessageDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalUnreadConversationCount",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "submittedTransactions",
                "name": "transactions",
                "storageKey": null,
                "args": [
                  (v32/*: any*/),
                  (v33/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.submitted"
                  }
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": (v31/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": "confirmedTransactionsMostRecent",
                "name": "transactions",
                "storageKey": null,
                "args": [
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": (v31/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": "vipChatEmail",
                "name": "userRelationships",
                "storageKey": null,
                "args": (v10/*: any*/),
                "concreteType": "UserRelationship",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userDataB",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "VipRepData",
                        "selections": (v35/*: any*/)
                      }
                    ]
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "tradeChatEmail",
                "name": "userRelationships",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "relationshipType",
                    "value": "TRADE"
                  },
                  (v9/*: any*/)
                ],
                "concreteType": "UserRelationship",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userDataB",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "TradeRepData",
                        "selections": (v35/*: any*/)
                      }
                    ]
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "allTransactions",
                "name": "transactions",
                "storageKey": null,
                "args": [
                  (v32/*: any*/),
                  (v33/*: any*/)
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": (v31/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": "initiatedTransactions",
                "name": "transactions",
                "storageKey": null,
                "args": [
                  (v32/*: any*/),
                  (v33/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.initiated"
                  }
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": (v31/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": "confirmedTransactions",
                "name": "transactions",
                "storageKey": null,
                "args": [
                  (v32/*: any*/),
                  (v33/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "sort",
                    "value": "createdDate asc"
                  },
                  (v34/*: any*/)
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": (v31/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "hasSessionCountryCode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "regInfo",
                "name": "regionalInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  (v36/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "showMarketingMessages",
            "selections": [
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isClient",
                "selections": [
                  {
                    "kind": "Condition",
                    "passingValue": false,
                    "condition": "hasUserId",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": "unregisteredUserMessages",
                        "name": "messageSet",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "isFirstTimeVisitor",
                            "variableName": "marketingBannerIsFirstTimeVisitor"
                          }
                        ],
                        "concreteType": "MessageSetModule",
                        "plural": true,
                        "selections": (v30/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasMarketingBannerPreviewVariables",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "previewMessages",
                    "name": "messageSet",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "setId",
                        "variableName": "marketingBannerPreviewSetId"
                      },
                      {
                        "kind": "Variable",
                        "name": "userType",
                        "variableName": "marketingBannerPreviewUserType"
                      }
                    ],
                    "concreteType": "MessageSetModule",
                    "plural": true,
                    "selections": (v30/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchRegionalInfo",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regionalInfo",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "countryCode",
                    "variableName": "userCountryCode"
                  },
                  (v17/*: any*/),
                  (v37/*: any*/)
                ],
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v36/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "incomeLevel",
                    "storageKey": null,
                    "args": [
                      (v37/*: any*/)
                    ],
                    "concreteType": "IncomeLevel",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "incomeBracket",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "incomePercentile",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v22/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "HeaderRefetchQuery",
    "id": "ferrum/244.0.0-2019-12-11T16:56:09.476Z/HeaderRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '38a0e50c4245b5278843d4ee93d59772';
export default node;
